import { AxiosRequestConfig } from 'axios';

import { fetcher } from '@hh.ru/front-static-app';

import { AreaLeavesDto } from 'src/types/area';

const HOST = '/shards/area/get_areas_suggest';

type QueryValue = string;

type ReturnType = AreaLeavesDto[];

declare global {
    interface FetcherGetApi {
        [HOST]: { queryParams: QueryValue; response: { items: ReturnType } };
    }
}

const findCity = async (query: QueryValue, reqConfig: AxiosRequestConfig = {}): Promise<ReturnType> => {
    const { data } = await fetcher.get<typeof HOST>(HOST, { params: { search: query }, ...reqConfig });
    return data.items;
};

export default findCity;
